import clsx from "clsx";
import Icon from "components/Icon/Icon";
import { forwardRef, useImperativeHandle, useState } from "react";

type Props = {
  title?: string;
  titleComponent?: React.ReactNode;
  content: React.ReactNode;
  className?: string;
  contentClassName?: string;
  rowClassName?: string;
};

export type ExpandableProps = {
  toggle: () => void;
};

export const Expandable = forwardRef<ExpandableProps, Props>((props, ref) => {
  const [isOpen, setIsOpen] = useState(false);

  const {
    title,
    content,
    titleComponent,
    className,
    contentClassName,
    rowClassName,
  } = props;

  const toggle = () => {
    setIsOpen((prev) => !prev);
  };

  useImperativeHandle(
    ref,
    () => {
      return {
        toggle: () => {
          toggle();
        },
      };
    },
    []
  );

  const containerClassName = clsx("flex flex-col", className);
  const contentContainerClassName = clsx(contentClassName ?? "p-4");
  const rowContainerClassName = clsx(
    "flex flex-row",
    rowClassName ?? "gap-4 items-center"
  );

  return (
    <div className={containerClassName}>
      <div className={rowContainerClassName} onClick={toggle}>
        <Icon name={isOpen ? "ChevronUp" : "ChevronDown"} className="w-6 h-6" />
        {titleComponent ?? (
          <h2 className="text-lg font-medium text-gray-900 flex flex-1">
            {title}
          </h2>
        )}
      </div>
      <div
        className={`flex-grow transition-all duration-300 mt-2 ${
          isOpen ? "block" : "hidden"
        }`}
      >
        <div className={contentContainerClassName}>{content}</div>
      </div>
    </div>
  );
});
